export default {
  methods: {
    /**
     * A data object to be used to create a new Service Titan Booking
     *
     * @typedef  {Object} ServiceTitanBooking
     * @property {string} name - Customer name (required)
     * @property {string} email - Customer email (required)
     * @property {string} phone - Customer phone (required)
     * @property {string} address - Customer address (required)
     * @property {string} city - Customer city (required)
     * @property {string} agentTag - Internal field used by Service Titan
     * @property {string} date - Requested booking date (required)
     * @property {string} zip - Customer zip
     * @property {string} time - Requested booking time
     * @property {string} message - Request details
     * @property {string} customerType - Type of lead. Values can be 'Commercial' or 'Residential'.
     * @property {Object[]} otherFields - An array of objects like:
     *                      { label: String, value: String }
     *                      That's used to pass additional data to the summary field in Service Titan
     */

    /**
    * Individual instances of Rocket Forms must provide this method on the
    * root Vue instance.
    *
    * @return  {ServiceTitanBooking}
    */
    prepareServiceTitanData () {
      // Use method defined on root instance
      if (typeof this.$root.prepareServiceTitanData !== 'undefined') {
        return this.$root.prepareServiceTitanData()
      } else {
        throw new Error('No prepareServiceTitanData method found. Please define a `prepareServiceTitan` method on your root Vue instance')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/serviceTitan.js